import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData } from "./data"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllPromotions } from "store/Marketing/actions"
import {sitename} from "../../../constants/constants";

const Marketing = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllPromotions())
  }, [])
  const Marketing = useSelector(state => state.marketing.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Marketing" />
        </Container>
        <Table data={Marketing} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Marketing)
